import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'



import Chart from 'vue2-frappe'
Vue.use(Chart)

import VueChartkick from 'vue-chartkick'
// import annotationPlugin from 'chartjs-plugin-annotation';
import CharT from 'chart.js'

// CharT.register(annotationPlugin);
Vue.use(VueChartkick, { adapter: CharT })

import numFormat from 'vue-filter-number-format';

Vue.filter('nbr', numFormat);

//vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import axios from 'axios'
import VueAxios from 'vue-axios'

import { getAccessToken } from './utils/auth';

axios.interceptors.request.use(function (config) {
  // console.log('the access token: ' , getAccessToken());
  // if (getAccessToken() != null) {
  //   config.headers.Authorization = `Bearer ${getAccessToken()}`;
  // }

  return config;
}, function (err) {
  return Promise.reject(err);
});

//var instance = axios.create();

// Variable to track if we're currently refreshing
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, async function (error) {
  const originalRequest = error.config;
  
  if (error && error.message && error.message == "Network Error" && !error.response) {
    window.location = '/error';
    return Promise.reject(error);
  }

  // Do something with response error
  if (error && (error.response.status + "").startsWith("50")) {
    window.location = '/error';
    return Promise.reject(error);
  }
  if (400 == error.response.status) {
    // Permite propagarea erorii 400 pentru a fi tratată în componentă
    return Promise.reject(error);
  } else if (error.response.status === 401 && !originalRequest._retry) {
    if (isRefreshing) {
      return new Promise(function(resolve, reject) {
        failedQueue.push({resolve, reject});
      }).then(token => {
        originalRequest.headers['AuthorizationToken'] = 'Bearer ' + token;
        return axios(originalRequest);
      }).catch(err => {
        return Promise.reject(err);
      });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const refreshSuccess = await store.dispatch('refreshToken');
      
      if (refreshSuccess) {
        const newToken = store.state.jwt;
        processQueue(null, newToken);
        originalRequest.headers['AuthorizationToken'] = 'Bearer ' + newToken;
        return axios(originalRequest);
      } else {
        throw new Error('Token refresh failed');
      }
    } catch (err) {
      processQueue(err, null);
      localStorage.clear();
      localStorage.clear();
      store.commit("SET_JWT", "");
      store.commit("SET_REFRESH_TOKEN", "");
      window.location = '/';
      return Promise.reject(err);
    } finally {
      isRefreshing = false;
    }
  } else if (error.response.status === 403) {
    localStorage.clear();
    localStorage.clear();
    store.commit("SET_JWT", "");
    store.commit("SET_REFRESH_TOKEN", "");
    window.location = '/';
  } else {
    return Promise.reject(error);
  }
});
//Vue.use(VueAxios, instance)// axios)

//progress bar
import CripLoading from "crip-vue-loading"


// Install component in to Vue instance and inject in to axios.
//Vue.use(CripLoading, {instance})
Vue.use(CripLoading, {
  axios: axios, 
  color:"#45b2d3", 
  height:"3px", 
  applyOnRouter:false })

Vue.use(VueAxios, axios)

//vue analytics
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-21173516-2',
  router
})

import VueAppInsights from 'vue-application-insights'
const APP_INSIGHTS = process.env.VUE_APP_APP_INSIGHTS;

const enableLoging = process.env.VUE_APP_Enable_Loging;


//if (enableLoging == true)
  Vue.use(VueAppInsights, {
    id: APP_INSIGHTS,
    router
  })


import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

const APP_BUGSNAG = process.env.VUE_APP_BUGSNAG;

if (enableLoging == true) {
  const bugsnagClient = bugsnag(APP_BUGSNAG)
  bugsnagClient.use(bugsnagVue, Vue)
}



import moment from 'moment'
moment.locale('ro');

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// Register service worker for PWA
import './registerServiceWorker'
